import React from 'react';

export default function Input({ label, value, onChange, type = 'text', placeholder, required, icon, style, error }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5, ...style }}>
      {label && (
        <label style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>
          {label}{required && <span style={{ color: '#FF3B30', marginLeft: 2 }}>*</span>}
        </label>
      )}
      <div style={{ position: 'relative' }}>
        {icon && (
          <span style={{
            position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)',
            color: '#9CA3AF', display: 'flex', alignItems: 'center'
          }}>{icon}</span>
        )}
        <input
          type={type} value={value} onChange={onChange} placeholder={placeholder}
          style={{
            width: '100%', padding: icon ? '8px 12px 8px 34px' : '8px 12px',
            border: `1px solid ${error ? '#FF3B30' : '#E5E7EB'}`,
            borderRadius: 8, fontSize: 13, color: '#1A1A2E',
            background: '#fff', outline: 'none', fontFamily: 'inherit',
            transition: 'border-color 0.15s'
          }}
          onFocus={e => e.target.style.borderColor = '#4A6CF7'}
          onBlur={e => e.target.style.borderColor = error ? '#FF3B30' : '#E5E7EB'}
        />
      </div>
      {error && <span style={{ fontSize: 11, color: '#FF3B30' }}>{error}</span>}
    </div>
  );
}

export function Select({ label, value, onChange, options = [], required, style, placeholder }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5, ...style }}>
      {label && (
        <label style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>
          {label}{required && <span style={{ color: '#FF3B30', marginLeft: 2 }}>*</span>}
        </label>
      )}
      <select value={value} onChange={onChange} style={{
        width: '100%', padding: '8px 12px', border: '1px solid #E5E7EB',
        borderRadius: 8, fontSize: 13, color: '#1A1A2E', background: '#fff',
        outline: 'none', fontFamily: 'inherit', cursor: 'pointer'
      }}>
        {placeholder && <option value="">{placeholder}</option>}
        {options.map(o => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
    </div>
  );
}

export function Textarea({ label, value, onChange, placeholder, rows = 3, style }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 5, ...style }}>
      {label && <label style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>{label}</label>}
      <textarea
        value={value} onChange={onChange} placeholder={placeholder} rows={rows}
        style={{
          width: '100%', padding: '8px 12px', border: '1px solid #E5E7EB',
          borderRadius: 8, fontSize: 13, color: '#1A1A2E', background: '#fff',
          outline: 'none', fontFamily: 'inherit', resize: 'vertical'
        }}
      />
    </div>
  );
}
